import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { logout } from "../actions/auth"
import {
	CampaignsPaginatedListState,
	CampaignsState,
	fetchCampaigns,
	getCampaignsPaginated,
	updateCampaign,
} from "../actions/campaigns"

const initialState: CampaignsPaginatedListState = {
	loading: false,
	loadingFetch: false,
	error: undefined,
	errorFetch: undefined,
	list: [],
	selected: undefined,
}

const campaignsPaginatedSlice = createSlice({
	name: "campaignsPaginated",
	initialState: initialState,
	reducers: {
		clearError: (state: CampaignsPaginatedListState) => {
			state.error = undefined
			state.loading = false
		},
		resetDefault: (state: CampaignsPaginatedListState) => {
			state.loading = false
			state.loadingFetch = false
			state.error = undefined
			state.errorFetch = undefined
			state.list = []
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(logout.fulfilled, () => initialState)
			.addCase(
				getCampaignsPaginated.pending,
				(state: CampaignsPaginatedListState) => {
					state.loading = true
					state.error = undefined
				}
			)
			.addCase(
				getCampaignsPaginated.fulfilled,
				(
					state: CampaignsPaginatedListState,
					action: PayloadAction<CampaignsState[]>
				) => {
					state.loading = false
					state.error = undefined
					state.list = action?.payload
				}
			)
			.addCase(
				getCampaignsPaginated.rejected,
				(state: CampaignsPaginatedListState, action) => {
					state.loading = false
					state.error = action?.payload.message
				}
			)
			.addCase(fetchCampaigns.pending, (state: CampaignsPaginatedListState) => {
				state.loadingFetch = true
				state.errorFetch = undefined
			})
			.addCase(
				fetchCampaigns.fulfilled,
				(
					state: CampaignsPaginatedListState,
					action: PayloadAction<CampaignsState[]>
				) => {
					state.loadingFetch = false
					state.errorFetch = undefined
					state.list = {
						nextUrl: action?.payload.nextUrl,
						page: {
							...action?.payload.page,
							content: [
								...state.list.page.content,
								...action?.payload.page.content,
							],
						},
					}
				}
			)
			.addCase(
				fetchCampaigns.rejected,
				(state: CampaignsPaginatedListState, action) => {
					state.loadingFetch = false
					state.errorFetch = action?.payload.message
				}
			)
			.addCase(
				updateCampaign.fulfilled,
				(
					state: CampaignsPaginatedListState,
					action: PayloadAction<CampaignsState>
				) => {
					state.list = {
						...state.list,
						page: {
							...state.list?.page,
							content: state.list.page.content.map(
								(campaign: CampaignsState) =>
									campaign.id === action?.payload?.data?.id
										? action?.payload?.data
										: campaign
							),
						},
					}
				}
			)
	},
})

export const { clearError, resetDefault } = campaignsPaginatedSlice.actions

export default campaignsPaginatedSlice.reducer
